var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Account White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Account-White",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,6.25 C14.65,6.25 6.25,14.65 6.25,25 C6.25,35.35 14.65,43.75 25,43.75 C35.35,43.75 43.75,35.35 43.75,25 C43.75,14.65 35.35,6.25 25,6.25 Z M23.9583333,12.5 C26.8402778,12.5 29.1666667,14.8263889 29.1666667,17.7083333 C29.1666667,20.5902778 26.8402778,22.9166667 23.9583333,22.9166667 C21.0763889,22.9166667 18.75,20.5902778 18.75,17.7083333 C18.75,14.8263889 21.0763889,12.5 23.9583333,12.5 Z M26.0416667,39.5833333 C21.2673611,39.5833333 17.046875,37.0436508 14.5833333,33.1944444 C14.640625,29.2460317 22.2222222,27.0833333 26.0416667,27.0833333 C29.8420139,27.0833333 37.4427083,29.2460317 37.5,33.1944444 C35.0364583,37.0436508 30.8159722,39.5833333 26.0416667,39.5833333 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhite);
export default __webpack_public_path__ + "static/media/account-white.589d822f89cdb766c13a2659c4daec54.svg";
export { ForwardRef as ReactComponent };